// extracted by mini-css-extract-plugin
export default {"logo":"OniLogo_logo__4jeHN","compact":"OniLogo_compact__xuq+x","full":"OniLogo_full__GVfkb"};